import rbacCheck from '@/rbac/rbacCheck';
import { useUserData } from '@/redux/selectors';

const useSeeChangeCloudPwd = () => {
  const userData = useUserData();
  const canSeeChangeCloudPwd: boolean = rbacCheck(
    userData.roles ?? [],
    '/settings/cloud-reset-password'
  ) as boolean;

  return canSeeChangeCloudPwd;
};

export default useSeeChangeCloudPwd;
